const { createContext } = require("react");

export const RedemptionVaultContext = createContext()